import {
  IPerformerData,
  IPerformerDataActiveEvents,
  IPerformerDataActiveTypeticketcollections,
  IPerformerMetadata,
} from 'meta/pages/v4/performer'

type Path = string

export type PerformerState = Record<
  Path,
  {
    details?: IPerformerData
    activeEvents?: {
      data: Record<number, IPerformerDataActiveEvents>
      metadata: IPerformerMetadata
    }
    activeTypeticketcollections?: {
      data: Record<number, IPerformerDataActiveTypeticketcollections>
      metadata: IPerformerMetadata
    }
    metadata?: object
  }
>

export const initialState: PerformerState = {}
